import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { userActions } from '@/store/user';
import { usePopups } from './usePopups';

export const useLoadingInit = (loadingText = 'Processing') => {
  const dispatch = useDispatch();
  const { showLoader } = usePopups();

  useEffect(() => {
    dispatch(userActions.hideAppContainer());
    showLoader(loadingText);
    return () => {
      dispatch(userActions.showAppContainer());
    };
  }, [dispatch, showLoader, loadingText]);
};

export const useLoadingState = (isLoading, loadingText = 'Processing') => {
  const { showLoader, hideLoader } = usePopups();

  useEffect(() => {
    if (isLoading) {
      showLoader(loadingText);
    } else {
      hideLoader();
    }
  }, [isLoading, loadingText, showLoader, hideLoader]);
};

